import React, { useEffect, useState } from "react";
import AvatarAPI from "../api/avatar";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomDate from "./sub_components/date";

const AvatarDetail = () => {
  const [dataToShow, setDataToShow] = useState([]);
  let params = useParams();

  useEffect(() => {
    AvatarAPI.viewAvatar(params)
      .then((response) => {
        setDataToShow(response.data);
      })
      .catch((error) => console.log(error));
  }, []);

  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.auth.currentUser);
  useEffect(() => {
    if (currentUser === null) {
      return navigate("/signin");
    }
  }, []);

  return (
    <div className="content">
      <div className="container-fluid pt-4 pb-4 px-4">
        <div className="page-title">
          <h1>Avatars</h1>
        </div>

        <div className="text-center rounded p-4 table-bg">
          <div className="table-responsive">
            <table className="table text-start align-middle table-bordered table-hover mb-0 text-center table-style table-bet-rounds-detail">
              <tbody>
                <tr>
                  <td colspan="2" className="text-center">
                    <img
                      style={{
                        maxWidth: "150px",
                        borderRadius: "50%",
                      }}
                      className="avatar_image"
                      src={dataToShow.avatar_url}
                      alt=""
                    />
                  </td>
                </tr>
                <tr>
                  <td width="280">Avatar ID</td>
                  <td>{dataToShow.id}</td>
                </tr>
                <tr>
                  <td width="280">Created at</td>
                  <td>
                    <CustomDate date={dataToShow.created_at} />
                  </td>
                </tr>
                <tr>
                  <td width="280">Avatar Link</td>
                  <td>{dataToShow.avatar_url}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvatarDetail;